export const FETCH_MORE_STRING = 'fetchMore';
export const CREATE_NEW_STRING = 'createNew';